import React from "react";
import MainInbox from "../pages/staff/inbox/MainInbox";

const StaffInboxRoute = () => {
  return (
    <div>
      <MainInbox />
    </div>
  );
};

export default StaffInboxRoute;
